import React, { FC } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { iModalBoxCoreProps } from "../../../types/modalBoxType";

import "./modalBoxCore.css";

const ModalBoxCore: FC<iModalBoxCoreProps> = ({
	open,
	onClose,
	className,
	children,
}) => {
	return (
		<>
			<Modal
				open={open}
				onClose={onClose}
				aria-labelledby="decline-event"
				aria-describedby="decline-event-description">
				<Box className={`modalBoxHold ${className}`}>{children}</Box>
			</Modal>
		</>
	);
};
export default ModalBoxCore;
